export const ipv4Re =
  /^(?<a>\d{1,3})\.(?<b>\d{1,3})\.(?<c>\d{1,3})\.(?<d>\d{1,3})$/;

export function isPrivateIPv4(host: string): boolean {
  const m = host.match(ipv4Re);
  if (!m || !m.groups) return false;
  const a = Number(m.groups.a);
  const b = Number(m.groups.b);
  // 10.0.0.0/8
  if (a === 10) return true;
  // 172.16.0.0/12
  if (a === 172 && b >= 16 && b <= 31) return true;
  // 192.168.0.0/16
  if (a === 192 && b === 168) return true;
  // 127.0.0.0/8 loopback
  if (a === 127) return true;
  return false;
}
